/* Myzan reviews - shared gallery engine
   Do modes:
     MyzanReviewsInit(sid, url, batch)  -> floating badge popup (click par load)
     MyzanReviewsPage(sid, url, batch)  -> poora page (khulte hi load)
   Dono ek hi card markup aur CSS classes use karte hain. */
(function () {
  var AVATAR = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12zm0 2.5c-3.3 0-9.8 1.6-9.8 4.9v2.4h19.6v-2.4c0-3.3-6.5-4.9-9.8-4.9z"/></svg>';
  var TICK = '<svg class="fbr-tick" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>';
  var PLAY = '<svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';

  function gallery(sid, dataUrl, batch, pageMode) {
    var grid = document.getElementById('myzanFbGrid-' + sid);
    if (!grid) return;
    var sentinel = document.getElementById('myzanFbSentinel-' + sid);
    var statusEl = document.getElementById('myzanFbStatus-' + sid);
    var countEl = document.getElementById('myzanFbCount-' + sid);
    var scroller = pageMode ? null : document.getElementById('myzanFbScroll-' + sid);
    var trigger = pageMode ? null : document.getElementById('myzanFbTrigger-' + sid);
    var overlay = pageMode ? null : document.getElementById('myzanFbOverlay-' + sid);
    var closeBtn = pageMode ? null : document.getElementById('myzanFbClose-' + sid);
    var lb = document.getElementById('myzanFbLb-' + sid);
    var lbImg = document.getElementById('myzanFbLbImg-' + sid);
    var lbVid = document.getElementById('myzanFbLbVid-' + sid);
    var lbName = document.getElementById('myzanFbLbName-' + sid);
    var lbDate = document.getElementById('myzanFbLbDate-' + sid);
    if (!pageMode && (!trigger || !overlay)) return;

    var data = null, shown = 0, loading = false, cols = [], io = null, vio = null, curIdx = 0, lastCols = 0;
    var BATCH = batch || 20;

    function setStatus(html) {
      if (!statusEl) return;
      statusEl.innerHTML = html || '';
      statusEl.style.display = html ? 'block' : 'none';
    }
    function colCount() {
      var w = window.innerWidth;
      if (w <= 600) return 2;
      if (pageMode && w >= 1100) return 4;
      return 3;
    }

    function buildColumns() {
      grid.innerHTML = '';
      cols = [];
      var n = colCount();
      for (var i = 0; i < n; i++) {
        var c = document.createElement('div');
        c.className = 'fbr-col';
        c.style.flexDirection = 'column';
        grid.appendChild(c);
        cols.push(c);
      }
      lastCols = n;
      shown = 0;
    }

    function makeCard(r, idx) {
      var item = document.createElement('div');
      item.className = 'fbr-item';
      var media = document.createElement('div');
      media.className = 'fbr-media';
      if (r.t === 'video') {
        var v = document.createElement('video');
        v.className = 'fbr-mediael';
        v.setAttribute('data-type', 'video');
        v.setAttribute('playsinline', '');
        v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'none';
        if (r.p) v.poster = r.p;
        v.src = r.s;
        media.appendChild(v);
        var bdg = document.createElement('div');
        bdg.className = 'fbr-vbadge';
        bdg.innerHTML = PLAY;
        media.appendChild(bdg);
        if (vio) vio.observe(v);
      } else {
        var im = document.createElement('img');
        im.className = 'fbr-mediael';
        im.setAttribute('data-type', 'image');
        im.decoding = 'async';
        im.alt = 'Myzan Review';
        im.src = r.s;
        media.appendChild(im);
      }
      item.appendChild(media);
      var meta = document.createElement('div');
      meta.className = 'fbr-meta';
      var user = document.createElement('div');
      user.className = 'fbr-user';
      var av = document.createElement('div');
      av.className = 'fbr-avatar';
      av.innerHTML = AVATAR;
      var nm = document.createElement('span');
      nm.className = 'fbr-name';
      nm.textContent = r.n || 'Verified Customer';
      user.appendChild(av);
      user.appendChild(nm);
      user.insertAdjacentHTML('beforeend', TICK);
      meta.appendChild(user);
      if (r.d) {
        var dt = document.createElement('span');
        dt.className = 'fbr-date';
        dt.textContent = r.d;
        meta.appendChild(dt);
      }
      item.appendChild(meta);
      item.addEventListener('click', function () { openLb(idx); });
      return item;
    }

    function renderMore() {
      if (!data || !data.length || !cols.length) return;
      var end = Math.min(shown + BATCH, data.length);
      for (var i = shown; i < end; i++) cols[i % cols.length].appendChild(makeCard(data[i], i));
      shown = end;
      if (shown >= data.length) {
        if (io && sentinel) io.unobserve(sentinel);
        setStatus('');
      }
    }

    function startObserver() {
      if (!sentinel || !('IntersectionObserver' in window)) return;
      if (io) io.disconnect();
      io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) renderMore();
      }, { root: scroller || null, rootMargin: '700px 0px' });
      sentinel.style.display = 'block';
      io.observe(sentinel);
    }

    if ('IntersectionObserver' in window) {
      vio = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          var v = es[i].target;
          if (es[i].isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else { v.pause(); }
        }
      }, { root: scroller || null, rootMargin: '150px 0px' });
    }

    function loadData() {
      if (data || loading) return;
      loading = true;
      setStatus('<span class="fbr-spin"></span><br>Reviews load ho rahe hain...');
      fetch(dataUrl, { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
        .then(function (txt) {
          data = JSON.parse(txt.trim());
          data.sort(function (a, b) { return (b.o || '').localeCompare(a.o || ''); });
          loading = false;
          if (countEl) countEl.textContent = data.length;
          setStatus('');
          buildColumns();
          renderMore();
          startObserver();
        })
        .catch(function () {
          loading = false; data = null;
          setStatus(pageMode ? 'Reviews load nahi ho sake. Page refresh karein.' : 'Reviews load nahi ho sake. Popup band kar ke dobara kholein.');
        });
    }

    function openPopup() { overlay.classList.add('open'); document.body.style.overflow = 'hidden'; loadData(); }
    function closePopup() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      var vs = grid.querySelectorAll('video.fbr-mediael');
      for (var i = 0; i < vs.length; i++) vs[i].pause();
    }

    function openLb(i) { if (!lb) return; curIdx = i; updateLb(); lb.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeLb() {
      if (!lb) return;
      lbVid.pause(); lbVid.removeAttribute('src'); lbVid.load();
      lb.classList.remove('open');
      if (pageMode) document.body.style.overflow = '';
    }
    function updateLb() {
      var r = data && data[curIdx];
      if (!r || !lb) return;
      lbVid.pause();
      if (r.t === 'video') {
        lbImg.style.display = 'none'; lbImg.removeAttribute('src');
        lbVid.src = r.l || r.s; lbVid.style.display = 'block'; lbVid.load();
        var p = lbVid.play(); if (p && p.catch) p.catch(function () {});
      } else {
        lbVid.style.display = 'none'; lbVid.removeAttribute('src');
        lbImg.src = r.l || r.s; lbImg.style.display = 'block';
      }
      if (lbName) lbName.textContent = r.n || 'Verified Customer';
      if (lbDate) lbDate.textContent = r.d || '';
    }
    function navLb(dir) {
      if (!data || !data.length) return;
      curIdx += dir;
      if (curIdx >= data.length) curIdx = 0;
      if (curIdx < 0) curIdx = data.length - 1;
      if (curIdx >= shown) renderMore();
      updateLb();
    }

    var rT = null;
    window.addEventListener('resize', function () {
      if (!data || !data.length) return;
      clearTimeout(rT);
      rT = setTimeout(function () {
        if (colCount() === lastCols) return;
        var upto = shown;
        buildColumns();
        while (shown < upto && shown < data.length) renderMore();
        startObserver();
      }, 200);
    });

    if (!pageMode) {
      trigger.addEventListener('click', openPopup);
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPopup(); }
      });
      if (closeBtn) closeBtn.addEventListener('click', closePopup);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    }

    var el;
    el = document.getElementById('myzanFbLbClose-' + sid); if (el) el.addEventListener('click', closeLb);
    el = document.getElementById('myzanFbLbPrev-' + sid); if (el) el.addEventListener('click', function (e) { e.stopPropagation(); navLb(-1); });
    el = document.getElementById('myzanFbLbNext-' + sid); if (el) el.addEventListener('click', function (e) { e.stopPropagation(); navLb(1); });
    if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });

    document.addEventListener('keydown', function (e) {
      var lbOpen = lb && lb.classList.contains('open');
      if (e.key === 'Escape') {
        if (lbOpen) closeLb();
        else if (!pageMode && overlay.classList.contains('open')) closePopup();
      } else if (lbOpen) {
        if (e.key === 'ArrowRight') navLb(1);
        if (e.key === 'ArrowLeft') navLb(-1);
      }
    });

    if (pageMode) loadData();
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  window.MyzanReviewsInit = function (sid, url, batch) { ready(function () { gallery(sid, url, batch, false); }); };
  window.MyzanReviewsPage = function (sid, url, batch) { ready(function () { gallery(sid, url, batch, true); }); };
})();
